<template>
  <a-form :form="form" id="form">
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-form-item label="Supplier Name">
          <a-auto-complete
            v-decorator="['nama_supplier', {rules: [{required: true},{ validator: validateSupplier }], initialValue : initialData.nama_supplier}]"
            placeholder="Type here to suggest existing supplier"
            :dropdownMatchSelectWidth="false"
            optionLabelProp="value"
            @search="handleSearch"
          >
          <template slot="dataSource">
            <a-select-option v-for="(items,index) in resultSuggestSupplier" :key="index" :value="items.nama">
              {{ items.nama }}
            </a-select-option>
          </template>
          </a-auto-complete>
        </a-form-item>
        <a-form-item label="Address">
          <a-input
            v-decorator="['alamat', {rules: [{required: true}], initialValue : initialData.alamat}]"
          />
        </a-form-item>
        <a-form-item label="Contact Person">
          <a-input
            v-decorator="['contact_person', {rules: [{required: true}], initialValue : initialData.contact_person}]"
          />
        </a-form-item>
        <a-form-item label="Email">
          <a-input
            v-decorator="['email', {rules: [{type: 'email', required: false}], initialValue : initialData.email}]"
          />
        </a-form-item>
        <a-form-item label="Type of Product">
          <a-select
            showSearch
            placeholder="Select Type of Product"
            v-decorator="['jenis_produk', {rules: [{required: true}], initialValue: initialData.jenis_produk}]"
          >
            <a-select-option key="Electronics Component">Electronics Component</a-select-option>
            <a-select-option key="Mechanical Part">Mechanical Part</a-select-option>
            <a-select-option key="Chemical">Chemical</a-select-option>
            <a-select-option key="Raw Material">Raw Material</a-select-option>
            <a-select-option key="Computer & Accessories">Computer & Accessories</a-select-option>
            <a-select-option key="Maintenance & Services">Maintenance & Services</a-select-option>
            <a-select-option key="Other">Other</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="No. NPWP">
            <a-input
              v-decorator="['no_npwp', { rules: [{ required: false }], initialValue: initialData.no_npwp }]"
            />
          </a-form-item>
      </a-col>
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-item label="Is PKP?">
              <a-radio-group
                buttonStyle="solid"
                v-decorator="['is_pkp', { rules: [{ required: true }], initialValue: initialData.is_pkp }]"
              >
                <a-radio-button value="1">Yes</a-radio-button>
                  <a-radio-button value="0">No</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-item label="Is Domestic?">
              <a-radio-group
                buttonStyle="solid"
                v-decorator="['is_domestic', { rules: [{ required: true }], initialValue: initialData.is_domestic }]"
              >
                <a-radio-button value="DN">Yes</a-radio-button>
                <a-radio-button value="LN">No</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Bank">
          <a-select
            showSearch
            placeholder="Select Bank Name"
            v-decorator="['bank', {rules: [{required: true}], initialValue : initialData.bank}]"
          >
            <a-select-option
              v-for="bank in getBank"
              :key="bank.code"
              :value="bank.name"
            >{{bank.name}} ({{bank.code}})</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="No. Account bank">
          <a-input
            v-decorator="['no_rekening', {rules: [{required: true}], initialValue : initialData.no_rekening}]"
            
          />
        </a-form-item>
        <a-form-item label="User Request">
          <a-select
            showSearch
            placeholder="Select User Request"
            v-decorator="['user_request', {rules: [{required: true}], initialValue : initialData.user_request}]"
          >
            <a-select-option
              v-for="karyawan in getAllKaryawan"
              :key="karyawan.tlc"
            >{{karyawan.tlc}} - {{karyawan.nama}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Category">
          <a-radio-group
            buttonStyle="solid"
            v-decorator="['kategori', {rules: [{required: true}], initialValue : initialData.kategori}]"
          >
            <a-radio-button
              v-for="item in getSupplierType"
              :key="item.key"
              :value="item.value"
            >{{item.label}}</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="Executive">
          <a-select
            showSearch
            placeholder="Select Executive"
            v-decorator="['bod', {rules: [{required: true}], initialValue: initialData.bod}]"
            @change="handleBOD"
          >
            <a-select-option v-for="data in bod" :key="data.tlc">{{data.nama}} ( {{data.tlc}} )</a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

export default {
  name: "Informasi",
  components: {},
  props: {
    data: {},
    mode: String,
  },
  data() {
    return {
      bod: [],
      resultSuggestSupplier: []
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getAllKaryawan", "getSupplierType", "getSupplierList", "getBank", "getAuth"]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          nama_supplier: "",
          alamat: "",
          contact_person: "",
          jenis_produk: "",
          no_rekening: "",
          bank: [],
          user_request: [],
          kategori: "Avionik",
          bod: "",
          is_pkp: "1",
          is_domestic: "DN",
          email: ""
        };
      } else {
        if (this.mode==="Edit"){
        return {
          nama_supplier: this.data[0].informasi.nama_supplier,
          alamat: this.data[0].informasi.alamat,
          contact_person: this.data[0].informasi.contact_person,
          jenis_produk: this.data[0].informasi.jenis_produk,
          no_rekening: this.data[0].informasi.no_rekening,
          bank: this.data[0].informasi.bank,
          user_request: this.data[0].informasi.user_request,
          kategori: this.data[0].informasi.kategori,
          bod: this.data[3].dokumenpendukung.approval_bod,
          is_pkp: this.data[0].informasi.is_pkp,
          is_domestic: this.data[0].informasi.is_domestic,
          no_npwp: this.data[0].informasi.no_npwp,
          email: this.data[0].informasi.email
          };
        }else{
          return {
          nama_supplier: this.data.nama_supplier,
          alamat: this.data.alamat,
          contact_person: this.data.contact_person,
          jenis_produk: this.data.jenis_produk,
          no_rekening: this.data.no_rekening,
          bank: this.data.bank,
          user_request: this.data.user_request,
          kategori: this.data.kategori,
          bod: this.data.bod,
          is_pkp: this.data.is_pkp,
          is_domestic: this.data.is_domestic,
          no_npwp: this.data.no_npwp,
          email: this.data.email
          };
        }
      }
    }
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    this.$store.dispatch("FETCH_SUPPLIER_LIST");

    axios({
      method: "get",
      url: this.$serviceUrl + "bod",
      params: {
        "X-API-KEY": this.getAuth.apikey
      },
      auth: {
        username: this.getAuth.username,
        password: this.getAuth.password
      }
    })
    .then(response => {
      //console.log(response);
      this.bod = response.data.bod;
    })
    .catch(err => {
      console.log(err.response);
      this.displayMessage("error-connection");
    });
  },
  methods: {
    isNumber(event, message) {
      /* To limit the number of digits after the decimal add the following line into the isNumber method:
      The \d{2} limits the entry of two digits. Change this to \d{1} to limit to one.
      if (/\.\d{2}/.test(message)) return event.preventDefault(); */
      if (!/\d/.test(event.key) &&  
        (event.key !== "." || /\./.test(message))  
      ) {
        this.displayMessage("error-only-number");
        return event.preventDefault();  
      }
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          console.log(err);
          this.displayMessage("form-warning");
          return;
        }

        let tsearch = values.nama_supplier.toLowerCase().replace(/^\s+|\s+$/gm,'')
        let rSearch = this.getSupplierList.filter((item)=>{return item.nama.replace(/\s/g, '').toLowerCase().indexOf(tsearch.replace(/\s/g, ''))>=0})

        if(this.mode=='Edit' && values.nama_supplier.toLowerCase()==this.initialData.nama_supplier.toLowerCase()){
          rSearch = []
        }

        if(rSearch.length>0){
          this.displayMessageValue("error-other", "Duplicate Supplier, input another please!");
          return;
        }

        Event.$emit("purchasingData", { informasi: values });
      });
    },
    handleBOD(data) {
      /* let filter = this.wo_bod.filter(
        obj => obj.tlc.toLowerCase().indexOf(data.toLowerCase()) >= 0
      ); */
    },
    handleNumeric(e){
      let valu = e.target.value;

      if (!Number(valu)) {
      return;
      }

      this.setState({ [e.target.name]: valu });
    },
    handleSearch(value){
      let result;
      if (!value) {
        result = [];
      } else if(value.length>=2){
        result = this.getSupplierList.filter((item)=>{return item.nama.toLowerCase().indexOf(value.toLowerCase())>=0})
      }
      this.resultSuggestSupplier = result;
    },
    validateSupplier(rule, value, callback){
        let tsearch = value.toLowerCase().replace(/^\s+|\s+$/gm,'')
        let rSearch = this.getSupplierList.filter((item)=>{return item.nama.replace(/\s/g, '').toLowerCase() == tsearch.replace(/\s/g, '')})

        if(this.mode=='Edit' && value.toLowerCase()==this.initialData.nama_supplier.toLowerCase()){
          rSearch = []
        }

        if(value!='' && value.length>=2 && rSearch.length>0){
          callback("Supplier is Already Exists!");
          return;
        }else{
          callback();
          return;
        }
    }
  }
};
</script>

<style>
</style>